import { AxiosResponse } from "axios";
import { SearchResult } from "../../../Model/Dto/SearchResult";
import { BEECatergoryDto } from "../../../Model/Dto/WSP/MerSETASDE";
import { MerSetaSDILookupDto, MerSetaSDITrainerDto, MerSetaSDITrainerSearchInput, MerSetaSDITrainerSearchResult, MerSetaSdi, MerSetaSdiSearchDto, MersetaSdiSearchRequest } from "../../../Model/Dto/WSP/MerSETASDI";
import { axiosWSPInstance } from "../../AxiosWSPInterceptor";
import * as ApiUrls from "./ApiUrl.merSETASDI";

export const MerSETASDIService = {
  GetMerSETACategoryInterventions: (): Promise<AxiosResponse<BEECatergoryDto[]>> => axiosWSPInstance.get(ApiUrls.CategoryInterventions),
  CreateMerSETASDI: (request: MerSetaSdi): Promise<AxiosResponse<number>> => axiosWSPInstance.post(ApiUrls.merSETASDI, request),
  GetById: (id: number): Promise<AxiosResponse<MerSetaSdi>> => axiosWSPInstance.get(`${ApiUrls.merSETASDI}/${id}`),
  UpdateMerSETASDI: (id: number, request: MerSetaSdi): Promise<AxiosResponse<null>> => axiosWSPInstance.put(`${ApiUrls.merSETASDI}?id=${id}`, request),
  DeleteMerSETASDI: (id: number): Promise<AxiosResponse<null>> => axiosWSPInstance.delete(`${ApiUrls.merSETASDI}/${id}`),
  SearchMerSetaSDIs: (request: MersetaSdiSearchRequest): Promise<AxiosResponse<SearchResult<MerSetaSdiSearchDto>>> => {
    const baseUrl = ApiUrls.merSETASDI;
    const queryParams = new URLSearchParams();

    queryParams.append('organisationId', request.organisationId.toString());    
    queryParams.append('pageNumber', request.pageNumber.toString());
    queryParams.append('pageSize', request.pageSize.toString());
    queryParams.append('searchValue', request.searchValue || '');
    if (request.personId && request.personId !== undefined) {
      queryParams.append('personId', request.personId);
    }    
    if (request.startDate) {
      queryParams.append('startDate', request.startDate.toDateString());
    }
    if (request.endDate) {
      queryParams.append('endDate', request.endDate.toDateString());
    }
    if (request.ColumnName && request.SortDirection !== undefined) {
      queryParams.append('columnName', request.ColumnName);
      queryParams.append('sortDirection', request.SortDirection.toString());

    }
    if (request.beeCategoryId && request.beeCategoryId.length > 0) {
      for (const categoryId of request.beeCategoryId) {
        queryParams.append('BeeCategories', categoryId.toString());
      }
    }

    if (request.interventionTypeId && request.interventionTypeId.length > 0) {
      for (const typeId of request.interventionTypeId) {
        queryParams.append('InterventionTypes', typeId.toString());
      }
    }

    if (request.interventionTitleId && request.interventionTitleId.length > 0) {
      for (const titleId of request.interventionTitleId) {
        queryParams.append('InterventionTitles', titleId.toString());
      }
    }

    return axiosWSPInstance.get(`${baseUrl}?${queryParams.toString()}`);
  },
  TrainerSearch: (request: MerSetaSDITrainerSearchInput): Promise<AxiosResponse<SearchResult<MerSetaSDITrainerSearchResult>>> =>
    axiosWSPInstance.post(ApiUrls.merSETASDITrainerSearch, request),
  GetUnassignedTrainers: (organisationId: number, merSETASDIId: number): Promise<AxiosResponse<MerSetaSDILookupDto[]>> =>
    axiosWSPInstance.get(`${ApiUrls.UnassignedTrainers}/${organisationId}/${merSETASDIId}`),
  GetTrainerDetails: (merSETASDIId: number, personId: string): Promise<AxiosResponse<MerSetaSDITrainerDto>> =>
    axiosWSPInstance.get(`${ApiUrls.merSETASDITrainer}/${merSETASDIId}/${personId}`),
  UpsertTrainer: (trainer: MerSetaSDITrainerDto): Promise<AxiosResponse> =>
    axiosWSPInstance.post(ApiUrls.merSETASDITrainer, trainer),
  DeleteTrainer: (trainerId: number, merSETASDIId: number): Promise<AxiosResponse> =>
    axiosWSPInstance.delete(`${ApiUrls.merSETASDITrainer}/${merSETASDIId}/${trainerId}`),
}